'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewsletterDataProvider = function () {
  function NewsletterDataProvider(Newsletter) {
    "ngInject";

    (0, _classCallCheck3.default)(this, NewsletterDataProvider);
    this.NewsletterService = Newsletter;
  }

  (0, _createClass3.default)(NewsletterDataProvider, [{
    key: 'editor',
    value: function editor() {
      // Initialize
      tinymce.EditorManager.editors = [];
      tinymce.init({
        selector: '.tinymce',
        plugins: ['paste', 'link', 'autoresize']
      });
      tinymce.init({
        selector: '.full-tinymce',
        toolbar1: 'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
        toolbar2: 'print preview media | forecolor backcolor emoticons ',
        image_advtab: true,
        plugins: ['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality', 'paste textcolor colorpicker textpattern imagetools toc']
      });
    }
  }, {
    key: 'getSubscribers',
    value: function getSubscribers(data) {
      return this.NewsletterService.loadSubscribers(data).then(function (result) {
        return result;
      });
    }
  }, {
    key: 'removeSubscriber',
    value: function removeSubscriber(id) {
      return this.NewsletterService.removeSubscriber(id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: 'getNewsletter',
    value: function getNewsletter(type) {
      return this.NewsletterService.getNewsletter(type).then(function (resp) {
        return resp;
      });
    }
  }]);
  return NewsletterDataProvider;
}();

// WEBPACK FOOTER //


exports.default = NewsletterDataProvider;


/** WEBPACK FOOTER **
 ** ./client/app/modules/newsletter/services/newsletter.dataprovider.service.js
 **/